(() => {
  'use strict';
  if (window.SomnilaSn85Stock) return;
  const readVariants = (scope, selector) => [...scope.querySelectorAll(selector)].flatMap(node => {
    try { const values = JSON.parse(node.textContent); return Array.isArray(values) ? values : []; }
    catch { return []; }
  });
  const quantityAllowed = (variant, count) => {
    const min = Number(variant.quantityMin ?? 1);
    const increment = Number(variant.quantityIncrement ?? 1);
    const max = variant.quantityMax == null ? null : Number(variant.quantityMax);
    return Number.isSafeInteger(count) && count >= min && increment > 0 && (count - min) % increment === 0 && (max == null || count <= max);
  };
  const update = (badge, variant, quantity) => {
    if (!badge) return;
    let state = 'unavailable';
    if (variant?.available === true) {
      const count = Number(quantity ?? variant.quantityMin ?? 1);
      state = !quantityAllowed(variant, count) ? 'quantityUnavailable' : variant.supplierStockConfirmed === true ? 'ready' : 'available';
    }
    const label = badge.querySelector('[data-sn85-stock-label]');
    const text = badge.dataset[state] || badge.dataset.unavailable || '';
    if (label && label.textContent !== text) label.textContent = text;
    badge.dataset.state = state === 'quantityUnavailable' ? 'quantity-unavailable' : state;
    const dot = badge.querySelector('[data-sn85-stock-dot]');
    if (dot) dot.hidden = state !== 'ready';
  };
  const updateProduct = (root, variant, quantity) => {
    const badge = root.querySelector('[data-sn85-context="product"]');
    const id = root.querySelector('[data-sn17-variant-id]')?.value || root.dataset.currentVariant;
    const choice = variant || readVariants(root, '[data-sn17-variants], [data-sn41-variants]').find(item => String(item.id) === String(id));
    update(badge, choice, quantity ?? root.querySelector('[data-sn17-quantity]')?.value);
  };
  const updateMixed = form => {
    const badge = form.querySelector('[data-sn85-context="mixed"]');
    const selects = [...form.querySelectorAll('[data-sn48-select]')];
    const available = selects.length > 0 && selects.every(select => {
      const option = select.selectedOptions[0];
      return Boolean(option?.value) && !option.disabled;
    });
    update(badge, { available, supplierStockConfirmed: badge?.dataset.sn85SupplierConfirmed === 'true' });
  };
  const updateComplement = item => {
    const select = item.querySelector('.sn33-complement-select');
    const id = select?.value || item.dataset.sn85InitialVariant;
    const variant = readVariants(item, '[data-sn85-complement-variants]').find(choice => String(choice.id) === String(id));
    update(item.querySelector('[data-sn85-context="complement"]'), variant, select?.value ? 1 : undefined);
  };
  const initialise = scope => {
    const badges = [...scope.querySelectorAll('[data-sn85-stock]')];
    if (scope.matches?.('[data-sn85-stock]')) badges.unshift(scope);
    badges.forEach(badge => {
      if (badge.dataset.sn85Context === 'card') {
        const card = badge.closest('[data-sn17-card]');
        if (!card) return;
        const variant = readVariants(card, '[data-card-variants]').find(item => String(item.id) === card.dataset.variant);
        update(badge, variant);
      } else if (badge.dataset.sn85Context === 'product') {
        const root = badge.closest('[data-sn17-product]');
        if (root) updateProduct(root);
      } else if (badge.dataset.sn85Context === 'complement') {
        const item = badge.closest('[data-sn33-complement]');
        if (item) updateComplement(item);
      } else {
        const form = badge.closest('[data-sn48-form]');
        if (form) updateMixed(form);
      }
    });
  };
  document.addEventListener('sn17:card-variant-change', event => {
    const card = event.target.closest?.('[data-sn17-card]');
    if (card) update(card.querySelector('[data-sn85-context="card"]'), event.detail?.variant);
  });
  document.addEventListener('sn17:purchase-change', event => {
    const root = event.target.closest?.('[data-sn17-product]');
    if (root) updateProduct(root, event.detail?.variant, event.detail?.quantity);
  });
  document.addEventListener('change', event => {
    if (event.target.matches?.('[data-sn48-select]')) {
      const form = event.target.closest('[data-sn48-form]');
      if (form) updateMixed(form);
    } else if (event.target.matches?.('.sn33-complement-select')) {
      const item = event.target.closest('[data-sn33-complement]');
      if (item) updateComplement(item);
    }
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  window.SomnilaSn85Stock = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
})();
